// 6 sample events
export const mockEventList = [
  {
    id: 0,
    title: 'Sports Instructor',
    host: 'Sam',
    createdAt: "2020-01-12T20:06:00.000Z",
    volunteerAt: null,
    startEndDate: 'Mon Feb 06, 2020 - Tue Jun 30, 2020',
    startEndTime: '1:00 PM - 9:00 PM',
    volunteer: false,
    organization: "I'RAISE Girls & Boys International",
    location: '495 3rd Ave. Brooklyn, NY 11215',
    imgURL: 'https://source.unsplash.com/ViJe3T1m5KE/800x450',
    desc: `<div class="event-desc"><p>We are looking for several Sports Instructors in the following sports: Martial Arts, Basketball, Football, Dance, with experience and passion for working with youth to volunteer his/her time for 3 hours a week at our Summer Camp Academy!</p></div>`,
    skills: [
      'Dance / Aerobics',
      'Baseball',
      'Martial Arts',
      'Dance',
      'Basketball'
    ],
    goodFor: ['Kids', 'Teens'],
    requirements: ['Background Check', '18 years +']
  },
  {
    id: 1,
    title: 'Creative Director',
    host: 'Buzz',
    createdAt: "2020-01-21T16:06:00.000Z",
    volunteerAt: null,
    startEndDate: 'Mon Feb 16, 2020 - Tue July 10, 2020',
    startEndTime: '12:00 PM - 2:00 PM',
    volunteer: false,
    organization: 'Hosh Yoga',
    location: '55 Nassau Ave. Brooklyn, NY 11222',
    imgURL: 'https://source.unsplash.com/4H67yWXO2-M/800x450',
    desc: `<div class="event-desc">
      <p><strong>Our Mission</strong></p><p><em>Enrichment education as a right of life rather than a luxury.</em></p><p>Hosh is here to provide a fair chance to explore healthier living for children through yoga, dance, meditation, workshops and strong community development in the Greenpoint and Williamsburg areas of Brooklyn, New York and beyond.</p><p>We invite volunteers to support us in any of the following area:</p><p>Creative Director</p><p>Photographer/Videographer</p><p>Hours: 3-6 hours per week. 2-3 days a week. Some remote work possible.</p><p>Join us! Email us today Info@hoshkids.org</p>
    </div>`,
    skills: [
      'Tutoring',
      'Mentoring',
      'Video editing',
      'Photography',
      'Creativity'
    ],
    goodFor: ['Kids', 'Teens'],
    requirements: ['Background Check', '18 years +']
  },
  {
    id: 2,
    title:
      "Change Kids' Lives",
    host: 'Millie',
    createdAt: "2019-09-02T03:06:00.000Z",
    volunteerAt: null,
    startEndDate: 'Mon Mar 01, 2020 - Fri Jun 30, 2020',
    startEndTime: '4:00 PM - 6:00 PM',
    volunteer: false,
    organization: 'Hosh Yoga',
    location: '55 Nassau Ave. Brooklyn, NY 11222',
    imgURL: 'https://source.unsplash.com/bTp32-t6K7c/800x450',
    desc: `<div class="event-desc"><p><strong>Use your passion, skills and experience to teach enrichment education in an NYC public school.<br></strong></p><br>Make a difference in a low income community, spreading our mission and growing your teaching skills--teaching stipends will be provided for all. Arts on a budget! Enrichment education for children as a right of life rather than a luxury is our mission. Join our vision to bring enrichment education to all children as we work with over 40 schools and over 6,000 school children. <p>Our <strong>teaching fellowship</strong> involves an stipended 12 week opportunity to teach in a local public pre-school, elementary, or middle school enrichment program once a week.</p></div>`,
    skills: [
      'Physical Education',
      'Community Outreach',
      'Teaching / Instruction',
      'Sports Coaching'
    ],
    goodFor: ['Adults', 'Teens'],
    requirements: ['Must be at least 20', 'Orientation or Training', '6 months']
  },
  {
    id: 3,
    title: 'Physical Activity Coach',
    host: 'Stephanie',
    createdAt: "2020-01-01T19:22:00.000Z",
    volunteerAt: null,
    startEndDate: 'Mon Jan 06, 2020 - Fri Sept 30, 2020',
    startEndTime: '1:00 PM - 2:00 PM',
    volunteer: false,
    organization: 'POSITIVE TRANSITIONING INC',
    location: 'Virtual Opportunity',
    imgURL: 'https://source.unsplash.com/mse1vdzZXjA/800x450',
    desc: `<div class="event-desc"><ul><li>Create daily workout regimes</li><li>Host online walking meetings</li><li>Create mid day quick workout challenges</li><li>Create other physical activity ideas</li></ul></div>`,
    skills: [
      'Physical Education',
      'Community Outreach',
      'Teaching / Instruction',
      'Sports Coaching'
    ],
    goodFor: ['Adults', 'Teens'],
    requirements: ['Must be at least 20', 'Orientation or Training']
  },
  {
    id: 4,
    title: 'Prayer Line Volunteer',
    host: 'Billy',
    createdAt: "2019-01-01T14:06:00.000Z",
    volunteerAt: null,
    startEndDate: 'Mon Jan 01, 2020 - Fri Sept 30, 2020',
    startEndTime: '3:00 PM - 5:00 PM',
    volunteer: false,
    organization: 'POSITIVE TRANSITIONING INC',
    location: 'Virtual Opportunity',
    imgURL: 'https://source.unsplash.com/rzmQOng8h8I/800x450',
    desc: `<div class="event-desc"><p>Philippians 2:3-4 Do nothing from selfishness or empty conceit, but with humility of mind regard one another as more important than yourselves; do not merely look out for your own personal interests, but also for the interests of others. Greetings! I am Karen Anne. I am just like you that have a heart to serve for the Lord. In serving the Lord it is one of the Lord's expectation for us to pray for one another. I am calling on all Prayer Intercessors to join me in our prayer room for Prayer Training on 01/20/2019 @2:00pm EST. The Prayer Intercessors that I am seeking would have the following gifts.</p> <ol><li> The willingness to listen with empathy.</li> <li> The gift of prayer</li> <li> A clear speaking voice </li> <li> The ability to be humble </li> <li> The Lord's power while praying</li> <li> Tremendous faith As, you are being led by the Holy Spirit </li> </ol><p>I ask that your prayerfully consider attending the training. Also, before the training I would love to get to know you. I want you to get to know me. When you sign up for the class before the class start I welcome you contacting me. 313.212.9284. Thank you for your time! I look forward to chatting with you. Yours faithfully,
    Karen Anne~~</p></div>`,
    skills: [
      'Networking',
      'People Skills',
      'Public Speaking',
      'Relationship Building',
      'Verbal / Written Communication'
    ],
    goodFor: ['All'],
    requirements: ['Orientation or Training']
  },
  {
    id: 5,
    title: 'Tutoring & Mentoring',
    host: 'Satoshi',
    createdAt: "2020-01-16T08:06:00.000Z",
    volunteerAt: null,
    startEndDate: 'Mon Mar 11, 2020 - Tue Oct 30, 2020',
    startEndTime: '3:00 PM - 5:00 PM',
    volunteer: false,
    organization: 'Youth Potential Academy',
    location: '10 Grand Army Plaza. Brooklyn, NY 11238',
    imgURL: 'https://source.unsplash.com/5fNmWej4tAA/800x450',
    desc: `<div class="event-desc"><p>Are you looking to be apart of an organization that passionately cares in making a difference within the youth community? Youth Potential Academy recognizes that each youth is different and may learn differently. This is why our curriculum is individualized, student centered, and creatively delivered to allow for optimal learning. We align academics with the students individual passions. Each student we serve at Youth Potential Academy is assessed and matched with professional and qualified instructors who are passionate about guiding the student towards greater academic and personal growth. <br><br>Student age group (10-17)<br>Travel reimbursement available.  </p><ul><li>On-site Location</li><li>Stipend Provided</li><li>Training Provided</li><li>Groups Welcome</li><li>International Volunteers Welcome</li></ul>  If interested apply today to aid the next generation.<p></p>`,
    skills: [
      'Tutoring',
      'Mentoring',
      'Math / Science Instruction',
      'Reading / Writing',
      'STEM',
      'Mathematics'
    ],
    goodFor: ['Kids', 'Teens'],
    requirements: ['Background Check', '18 years +']
  }
];
